module.exports = __webpack_public_path__ + "img/opensea-logo-flat-colored-blue.d7148927.svg";